import React from 'react';
import PropTypes from 'prop-types';
import styles from './SmallTalkHeader.scss';

function SmallTalkHeader({ title }) {
  return (
    <div className={styles.smallTalkHeader}>
      <div className={styles.smallTalkHeaderIcon} />
      <div className={styles.smallTalkHeaderText}>{title}</div>
    </div>
  );
}

SmallTalkHeader.propTypes = {
  title: PropTypes.string,
};

SmallTalkHeader.defaultProps = {
  title: '',
};

export default SmallTalkHeader;
